module.exports = __webpack_public_path__ + "img/jb.8621cfc9.png";